import { Route } from '@angular/router';
import { customizationResolver } from 'tofe-customization';
import { languageResolver } from 'tofe-language';
import { processResolver } from 'tofe-session';

/* istanbul ignore next */
export const appRoutes: Route[] = [
  {
    path: '',
    resolve: {
      customization$: customizationResolver,
      process$: processResolver,
      language: languageResolver,
    },
    loadComponent: () => import('./core/pages/main-page.component').then((mod) => mod.MainPageComponent),
  },
  {
    resolve: {
      customization$: customizationResolver,
      language: languageResolver,
    },
    path: 'playground',
    loadComponent: () => import('./core/pages/playground-page.component').then((mod) => mod.PlaygroundPageComponent),
  },
  {
    resolve: {
      language: languageResolver,
    },
    path: 'page-not-found',
    loadComponent: () => import('./core/pages/not-found-page.component').then((mod) => mod.NotFoundPageComponent),
  },
  {
    resolve: {
      language: languageResolver,
    },
    path: '**',
    redirectTo: '/page-not-found',
  },
];
